(function(){
  function init(root, options){
    options = options || {};
    const player = root;
    if (player.dataset.vpInited === 'true') return;
    player.dataset.vpInited = 'true';

    const toggleButton = player.querySelector('[data-video-toggle]');
    const toggleLabel = player.querySelector('[data-video-toggle-label]');
    const videoElement = player.querySelector('.video-player__video-element');
    const shouldAutoplay = player.getAttribute('data-autoplay') === 'true';
    const deferAutoplay = player.getAttribute('data-defer-autoplay') === 'true';

    if (!videoElement || !toggleButton) return;

    function setLabelPlaying(isPlaying){
      if (!toggleLabel) return;
      const pauseLabel = toggleButton.dataset.pauseLabel || 'Pause';
      const playLabel = toggleButton.dataset.playLabel || 'Play';
      toggleButton.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
      toggleLabel.textContent = isPlaying ? pauseLabel : playLabel;
    }

    function markReady(){ if (!player.classList.contains('is-ready')) player.classList.add('is-ready'); }

    function startPlayback(){
      player.classList.add('is-playing');
      player.classList.add('is-ready');
      setLabelPlaying(true);
      try{
        // Preserve current audio state; play/pause should never force mute.
        // load() resets properties from HTML attributes, so restore muted after.
        const keepMuted = videoElement.muted;
        videoElement.playsInline = true;
        const alreadyLoading = videoElement.getAttribute('preload') === 'auto' &&
          (videoElement.readyState >= 1 || !videoElement.paused);
        if (videoElement.hasAttribute('data-lazy') || !alreadyLoading) {
          videoElement.load();
        }
        videoElement.muted = keepMuted;
        const p = videoElement.play();
        if (p && typeof p.then === 'function') p.catch(function(){ player.classList.remove('is-playing'); setLabelPlaying(false);});
        setTimeout(markReady, 100);
      }catch(e){ player.classList.remove('is-playing'); setLabelPlaying(false); }
    }

    function pausePlayback(){
      try { videoElement.pause(); }
      catch(e){ console.error('video-player: failed to pause video', e); }
      player.classList.remove('is-playing');
      setLabelPlaying(false);
    }

    player.startPlayback = startPlayback;
    player.pausePlayback = pausePlayback;

    videoElement.addEventListener('canplay', markReady, { once: true });
    videoElement.addEventListener('loadeddata', markReady, { once: true });
    videoElement.addEventListener('playing', markReady, { once: true });
    videoElement.addEventListener('play', function(){
      player.classList.add('is-playing');
      setLabelPlaying(true);
    });
    videoElement.addEventListener('pause', function(){
      player.classList.remove('is-playing');
      setLabelPlaying(false);
    });
    videoElement.addEventListener('ended', function(){
      player.classList.remove('is-playing');
      setLabelPlaying(false);
    });

    if (shouldAutoplay && !deferAutoplay && options.autoplay !== false) startPlayback();

    toggleButton.addEventListener('click', function(ev){
      ev.preventDefault(); ev.stopPropagation();
      if (videoElement.paused) startPlayback(); else pausePlayback();
    });

    // Keyboard accessibility - allow Enter and Space to control video
    toggleButton.addEventListener('keydown', function(ev){
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault(); ev.stopPropagation();
        if (videoElement.paused) startPlayback(); else pausePlayback();
      }
    });

    // Make video clickable for keyboard users who focus on it
    videoElement.addEventListener('keydown', function(ev){
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault(); ev.stopPropagation();
        if (videoElement.paused) startPlayback(); else pausePlayback();
      }
    });
    // Audio control toggle (optional)
    const audioToggleButton = player.querySelector('[data-audio-toggle]');
    const audioToggleLabel = audioToggleButton ? audioToggleButton.querySelector('[data-audio-toggle-label]') : null;

    function updateAudioState(){
      const unmuteLabel = audioToggleButton.getAttribute('data-unmute-label') || 'Unmute video';
      const muteLabel = audioToggleButton.getAttribute('data-mute-label') || 'Mute video';
      const isMuted = videoElement.muted;

      if (isMuted) {
        player.classList.add('is-audio-off');
        player.classList.remove('is-audio-on');
        audioToggleButton.setAttribute('aria-label', unmuteLabel);
        audioToggleButton.setAttribute('aria-pressed', 'false');
        if (audioToggleLabel) {
          audioToggleLabel.textContent = unmuteLabel;
        }
      } else {
        player.classList.add('is-audio-on');
        player.classList.remove('is-audio-off');
        audioToggleButton.setAttribute('aria-label', muteLabel);
        audioToggleButton.setAttribute('aria-pressed', 'true');
        if (audioToggleLabel) {
          audioToggleLabel.textContent = muteLabel;
        }
      }
    }

    if (audioToggleButton) {
      // Initialize state from current muted attribute
      updateAudioState();
      // Keep icon/label in sync if mute state changes outside the button.
      videoElement.addEventListener('volumechange', updateAudioState);
      audioToggleButton.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        videoElement.muted = !videoElement.muted;
        updateAudioState();
      });
    }
  }

  // Initialize video players within a scope (used by carousel sections)
  window.initVideoPlayers = function(root, options) {
    const scope = root || document;
    const players = scope.querySelectorAll ? scope.querySelectorAll('.video-player') : [];
    players.forEach(function(player) { init(player, options); });
  };

  // Start playback on an initialized video player
  window.playVideoPlayer = function(player) {
    if (!player) return;
    if (player.dataset.vpInited !== 'true') init(player, { autoplay: false });
    if (typeof player.startPlayback === 'function') player.startPlayback();
  };

  // Pause an initialized video player
  window.pauseVideoPlayer = function(player) {
    if (!player) return;
    if (typeof player.pausePlayback === 'function') {
      player.pausePlayback();
      return;
    }
    const videoElement = player.querySelector('.video-player__video-element');
    if (videoElement) videoElement.pause();
  };

  document.querySelectorAll('.video-player:not([data-defer-autoplay])').forEach(init);

  document.addEventListener('shopify:section:load', function(e){
    const n = e.target && e.target.querySelectorAll ? e.target.querySelectorAll('.video-player:not([data-defer-autoplay])') : [];
    n && n.forEach(init);
  });
})();
